import ReactSwitch from 'react-switch'
import './Switch.scss'
import cn from 'clsx'
export const Switch = ({
  onChange,
  checked,
  classNames,
  disabled,
}: {
  onChange: (checked: boolean) => void
  checked: boolean
  classNames?: string
  disabled?: boolean
}) => {
  return (
    <ReactSwitch
      className={cn('switch', checked && 'checked', classNames)}
      checkedIcon={false}
      uncheckedIcon={false}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      width={28}
      height={16}
    />
  )
}
